import axios from '@axios'
import useJwt from './extend/useJwt'

const { jwt } = useJwt(axios, {})
export default jwt
